import Select from "@/Components/Select/Select";
import useLiveFilters from "@/shared/atoms/useLiveFilters";
import useCommon from "@/shared/hooks/useCommon";
import useIsMobileHook from "@/shared/hooks/useIsMobileHook";
import useUserSettingsQuery from "@/shared/queries/user/useUserSettingsQuery";
import { orderStatusses } from "@/shared/utils/constant";

const LiveStatussesFiltersDesktop = () => {
  const t = useCommon();
  const { data } = useUserSettingsQuery();
  const [filters, setFilters] = useLiveFilters();
  const handleFilterChange = (status: number) => {
    setFilters((filters) =>
      filters.includes(status)
        ? filters.filter((filter) => filter !== status)
        : [...filters, status]
    );
  };

  return (
    !data.show_only_new_orders && (
      <div
        data-tour="live-orders.status-filters"
        className="mr-8 mt-4 flex flex-wrap md:mt-0"
      >
        {orderStatusses.map((status) => (
          <div
            onClick={() => handleFilterChange(status.value[0])}
            key={status.value[0]}
            className={`ml-4 cursor-pointer ${filters.includes(status.value[0]) ? "line-through" : ""}`}
          >
            {t(`orders_live.${status.translationKey}`)}
          </div>
        ))}
      </div>
    )
  );
};

const LiveStatussesFiltersMobile = () => {
  const t = useCommon();
  const [filters, setFilters] = useLiveFilters();
  const handleFilterChange = (status: number[]) => {
    const values = orderStatusses
      .filter((s) => !status.includes(s.value[0]))
      .map((s) => s.value[0]);
    setFilters(values);
  };
  return (
    <div className="my-4 basis-full">
      <Select
        zIndex={10}
        isMulti
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        }}
        menuPortalTarget={document.getElementById("root")}
        options={orderStatusses}
        getOptionLabel={(option) => t(`${option.translationKey}`)}
        getOptionValue={(option) => option.value[0]}
        value={orderStatusses.filter(
          (status) => !filters.includes(status.value[0])
        )}
        onChange={(e) => {
          handleFilterChange(e.map((status) => status.value[0]));
        }}
      />
    </div>
  );
};

const LiveStatussesFilters = () => {
  const isMobile = useIsMobileHook();
  return isMobile ? (
    <LiveStatussesFiltersMobile />
  ) : (
    <LiveStatussesFiltersDesktop />
  );
};

export default LiveStatussesFilters;
